<template>
    <div class="pa-2">
        <!-- dialog -->
		<v-dialog v-model="dialog" max-width="300">
			<v-form ref="form" :disabled="submitLoading" @submit.prevent="submit">
				<v-card>
					<v-card-title>
						<span>{{ `${!itemId ? $T('add') : $T('edit')} ${$T('reminder-type')}` }}</span>
						<v-spacer />
						<v-btn icon @click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									v-model="name"
									:label="$T('inputs.name')"
									dense
									outlined
									hide-details
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="secondary" :loading="submitLoading" type="submit">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

        <!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			module="remindersTypes/delete"
			:parameters="{ id: itemId }"
			@on-delete="fetchReminderTypes()"
		>
			{{ $T('RemindersTypes.delete-message-reminder-type') }}
		</v-delete-dialog>

        <!-- add button -->
        <div class="d-flex justify-end mb-2">
            <v-btn small color="addRow white--text" @click="dialog = true;">
                {{$T('add')}} {{$T('reminder-type')}}
            </v-btn>
        </div>

        <bee-handy-table
        	:headers="headers"
        	:items="remindersTypes"
            :loading="loading"
			fixed-header
			:height="$vuetify.breakpoint.height - 150"
			pagination-on-scroll
			dense
			zebra
			:shown-rows-text="$T('shown-rows-text')"
			:data-table-props="{ disableSort: true }"
        >
            <template v-slot:item.actions="{ item }">
                <tooltip :text="$T('tooltips.preview')">
                    <v-btn small icon @click="itemId = item.id; dialog = true;">
                        <v-icon size="20" color="edit-color">$edit</v-icon>
                    </v-btn>
                </tooltip>
                <tooltip :text="$T('tooltips.delete')">
                    <v-btn small icon @click="itemId = item.id; deleteDialog = true;">
                        <v-icon size="20" color="alert">$delete</v-icon>
                    </v-btn>
                </tooltip>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import rules from '@/utils/validation rules'
import { mapGetters, mapState } from 'vuex'
export default {
    name: 'RemindersTypes',

    data() {
        return {
            rules,

            submitLoading: false,
            loading: false,
            
            name: null,

            itemId: null,
            dialog: false,
            deleteDialog: false,

            headers: [
                { text: this.$T('headers.name'), name: 'name', value: 'name' },
                { text: '', name: 'actions', value: 'actions', columnClass: 'px-2', width: 80, noNotAvailableText: true }
            ]
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.itemId) {
                    this.name = this.getReminderTypeById(this.itemId).name;
                }
            } else {
                this.$refs.form.reset();
                this.itemId = null;
            }
        },

        deleteDialog(val) {
            if (!val) this.itemId = null;
        }
    },

    computed: {
        ...mapState({
            remindersTypes: state => state.remindersTypes.remindersTypes
        }),
        ...mapGetters({
            getReminderTypeById: 'remindersTypes/getReminderTypeById'
        })
    },

    methods: {
        fetchReminderTypes() {
            this.loading = true;
            this.$store.dispatch('remindersTypes/fetchAll').finally(() => {
                this.loading = false;
            });
        },

        submit() {
            if (this.$refs.form.validate()) {
                this.submitLoading = true;
                const actionName = !this.itemId ? 'create' : 'update';
                this.$store.dispatch(`remindersTypes/${actionName}`, {
                    id: this.itemId,
                    name: this.name
                }).then(() => {
					this.fetchReminderTypes();
					this.$eventBus.$emit(
						'show-snackbar',
						!this.itemId ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
					this.dialog = false;
				}).catch((err) => {
					err.default && err.default(
						!this.itemId ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						false
					);
				}).finally(() => {
					this.submitLoading = false;
				})
            }
        }
    },

    created() {
        if (this.remindersTypes.length === 0) {
            this.fetchReminderTypes();
        }
    }
}
</script>

<style>

</style>